// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item[data-v-744e4028] .el-input__inner {\r\n    color: #696969;\n}\r\n", ""]);
// Exports
module.exports = exports;
